/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/09/09 13:59:01
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
import { SupcanReport } from "@newview/supcanreport";
import { getOSSClient } from "@newview/tools";
import { ReportTemplateApi, ReportTemplateCellApi } from "@newview/basics-v2-api";
import { ReportOption } from "./ReportType";

@Component({
    components: {

    }
})
export default class Report extends BaseVue {

    //#region 接口定义区

    private readonly reportTemplateApi: ReportTemplateApi = new ReportTemplateApi();
    private readonly reportTemplateCellApi: ReportTemplateCellApi = new ReportTemplateCellApi();

    //#endregion 接口定义区

    //#region 变量定义区

    rootPath: string = "basics/report/template";
    isInitReport: boolean = false;
    report = new SupcanReport();
    reportId: string = this.getUniqueCode();
    loadReporting: boolean = false;

    ossClient: any;
    reportTemplateData: any = {};
    reportTemplateCellDatas: any[] = [];

    option?: ReportOption; // 报表参数

    //#endregion 变量定义区

    //#region 事件定义区

    async created() {
        this.ossClient = await getOSSClient();
    }

    mounted() {

    }

    //#endregion 事件定义区

    //#region 方法定义区

    /**
     * 设置参数
     * @param option 
     */
    public setOption(option: ReportOption) {
        this.option = option;
        this.loadReporting = true;

        // 1. 加载报表信息
        this.report.init(this.reportId, "noneBar", async (id: string) => {
            if (this.report.AFId == id) {
                this.report.subscribeEvent(
                    "SelChanged,CurSelChanged,Clicked,DblClicked,WorkSheetSelChanged,EditChanged"
                );

                // 1. 加载报表模板配置信息
                let apiResult = await this.reportTemplateApi.getEntityByFilter(this.getQueryWrapper().eq("TemplateNo", option.reportNo).eq("IsEnable", 1));
                this.reportTemplateData = this.parseApiResult(apiResult);

                // 2. 加载报表Cell信息
                apiResult = await this.reportTemplateCellApi.getEntities(this.getQueryWrapper()
                    .eq("ProjectId", this.getProjectDataId())
                    .eq("TemplateId", this.reportTemplateData.Id));
                this.reportTemplateCellDatas = this.parseApiResult(apiResult);
                this.renderReport(this.reportTemplateData.TemplatePath);
            }
        }, async () => {
            this.bindReportEvent();
        });
    }

    /**
     * 获取文件路径
     * @returns 
     */
    getFilePath(path) {
        return `${this.rootPath}/${path}.xml`
    }

    /**
     * 渲染报表
     * @param path 
     */
    async renderReport(path) {
        const url = this.ossClient.signatureUrl(this.getFilePath(path));
        let result: any = await this.$getJson(url);
        if (result.code == 500) {
            this.report.addWorksheet("sheet1");
            this.loadReporting = false;

            // 执行初始化完成事件
            if (!this.isNull(this.option!.event) && !this.isNull(this.option!.event!.event_inited)) {
                this.option!.event!.event_inited!(false);
            }

            // 2. 设置报表配置
            this.setReport();
        } else {
            this.report.grayWindow("")
            this.report.build(result, async () => {
                this.loadReporting = false;

                // 1. 执行初始化完成事件
                if (!this.isNull(this.option!.event) && !this.isNull(this.option!.event!.event_inited)) {
                    this.option!.event!.event_inited!(true);
                }

                // 2. 设置报表配置
                this.setReport();
            });
        }
    }

    /**
     * 设置报表配置
     */
    setReport() {
        if (!this.isNull(this.option!.setting) && !this.isNull(this.option!.setting!.canEdit)) {
            this.report.addEditAbleOnly(this.option!.setting!.canEdit ? `bgColor=T` : `bgColor=#FFF`);
        }
    }

    /**
     * 绑定报表事件
     */
    bindReportEvent() {
        const self = this;
        this.report.BindReportEvent((id, event, row, col, p3, p4) => {
            if (id == self.report.AFId) {
                switch (event) {
                    case 'SelChanged': // 选择单元格事件
                        if (!this.isNull(this.option!.event) && !this.isNull(this.option!.event!.event_cellClick)) {
                            this.option!.event!.event_cellClick!(row, col);
                        }
                        break;
                    case "Previewed": // 预览结束
                        if (!this.isNull(this.option!.event) && !this.isNull(this.option!.event!.event_previewed)) {
                            this.option!.event!.event_previewed!();
                        }
                        break;
                }
            }
        });
    }

    /**
     * 自适应A4
     */
    doAutoA4() {
        this.report.autoFitPaperSize();
        this.success("自适应A4完成");
    }

    /**
     * 打印预览
     */
    doPrintView() {
        this.report.printView();
    }

    /**
     * 打印
     */
    doPrint() {
        this.report.printAll();
    }

    /**
     * 设置数据
     * @param data 
     */
    setData(data) {
        console.log("setData", this.reportTemplateCellDatas, data);
        for (const item of this.reportTemplateCellDatas) {
            let value = data[item.CellField];
            this.report.setCellValue(item.CellRow, item.CellCol, value);
        }
    }
    //#endregion 方法定义区
}